// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "f500f72e56606ec9","191": "e9c0b2d5f73449c6","396": "cb3bb8a3e5805ec2","460": "249dfe9d5cb9c49b","498": "3c91acf582337503","917": "a1c557db79efc8c7","985": "77271702f18f7ae2",}[chunkId] + ".chunk.js"
}